import { jsx } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { spacing } from "./auth-service-tools25.js";
const cardBody = /*#__PURE__*/css({
  padding: `${spacing.X24} ${spacing.X24}`,
  display: "flex",
  gap: spacing.X24,
  flexDirection: "column"
}, process.env.NODE_ENV === "production" ? "" : ";label:cardBody;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvYXBwL25vZGVfbW9kdWxlcy9AaW5zdGFjYXJ0L2lwcC1hdXRoLXNlcnZpY2UtdG9vbHMvZGlzdC9hdXRoLXNlcnZpY2UtdG9vbHM5Ni5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUIiLCJmaWxlIjoiL3Zhci9hcHAvbm9kZV9tb2R1bGVzL0BpbnN0YWNhcnQvaXBwLWF1dGgtc2VydmljZS10b29scy9kaXN0L2F1dGgtc2VydmljZS10b29sczk2LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcbmltcG9ydCB7IHNwYWNpbmcgfSBmcm9tIFwiLi9hdXRoLXNlcnZpY2UtdG9vbHMyNS5qc1wiO1xuY29uc3QgY2FyZEJvZHkgPSBjc3Moe1xuICBwYWRkaW5nOiBgJHtzcGFjaW5nLlgyNH0gJHtzcGFjaW5nLlgyNH1gLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiBzcGFjaW5nLlgyNCxcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIlxufSk7XG5jb25zdCBDYXJkQm9keSA9ICh7XG4gIGNoaWxkcmVuLFxuICBjbGFzc05hbWVcbn0pID0+IC8qIEBfX1BVUkVfXyAqLyBqc3goXCJkaXZcIiwgeyBjc3M6IGNhcmRCb2R5LCBjbGFzc05hbWUsIGNoaWxkcmVuIH0pO1xuZXhwb3J0IHtcbiAgQ2FyZEJvZHlcbn07XG4vLyMgc291cmNlTWFwcGluZ1VSTD1hdXRoLXNlcnZpY2UtdG9vbHM5Ni5qcy5tYXBcbiJdfQ== */");

const CardBody = (_ref) => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("div", {
    css: cardBody,
    className,
    children
  });
};

export { CardBody };